import React from "react";
import Button from "../../../../Button";
import { CARD_TYPE } from "../../../../../types/card-type";

const TicketcardCardDetail = () => {
    return <>
        <Button block to={`/usuario/wallet/comprar/${CARD_TYPE.TICKETCARD}`} className="mb-5">
            Comprar otra TicketCard
        </Button>
    </>;
};

export default TicketcardCardDetail;
